import "./css/ProductoCard.css"
import { useEffect, useContext, useState } from "react"
import { AppContext } from "../../App"
import { useNavigate } from "react-router-dom"
import Swal from "../../shared/SweetAlert"
import NoImage from "../../pages/assets/productos/no-image.png"
import ButtonWithIcon from "../controls/ButtonWithIcon"
import '../../shared/CurrencyGTQ'
import '../../shared/ConditionsProvider'
import { PRECIO_CONDICION } from "../../shared/ConditionsProvider"
import PromoCondi from "../misc/PromoCondi";
import IconAddShoppingCart from "../icons/IconAddShoppingCart";
import IconHeartPlus from "../icons/IconHeartPlus";
import IconHelpFill from "../icons/IconHelpFill"

//import { Tooltip } from "@material-ui/core"
//import Tooltip from '@mui/material/Tooltip';

const ProductoCard = (props) => {

  const appContext = useContext(AppContext)
  const navigate = useNavigate();

  const [errorImage, setErrorImage] = useState(false)
  const [isFavorito, setFavorito] = useState(false)
  const [loaderFavorito, setLoaderFavorito] = useState(false)
  const [loaderCompra, setLoaderCompra] = useState(false)
  const [existenciasPopUp, setExistenciasPopUp] = useState("")
  const [mayorista, setMayorista] = useState(false)
  const [promos, setPromos] = useState([])

  useEffect(() => {
    setMayorista(appContext.appState.mayorista)

    // eslint-disable-next-line
  }, [appContext.appState.mayorista])


  useEffect(() => {
    setFavorito(props.Producto.EsFavorito)
    props.Producto.Existencia.forEach(element => {
      if (existenciasPopUp.length === 0) {
        return setExistenciasPopUp(values => { return values + existenciasPopUp + element.NombreSucursal.toLowerCase().split(" ").map(word => word[0].toUpperCase() + word.substring(1)).join(" ") + " " + element.Existencia + "\n" })
      }
    });

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setMayorista(appContext.appState.mayorista)

    // eslint-disable-next-line
  }, [appContext.appState.mayorista])

  const AñadirProducto = async (producto, existencias) => {
    try {
      setLoaderCompra(true);

      if (existencias.length === 0) {
        throw new Error("El producto no tienen existencias.")
      }

      if (localStorage.getItem("id-carrito") === null) {
        sessionStorage.setItem("codigo", producto.Codigo)
        navigate("/entrega")
      } else {
        await fetch(
          new Request(
            appContext.appState.baseUrl +
            "carrito/producto/" + localStorage.getItem("id-carrito") + "?codigoInventario=" + producto.Codigo + "&cantidad=1&tipoPago=efectivo",
            {
              method: "POST",
              headers: {
                "Content-type": "application/json"
              }
            }
          )
        )
          .then((response) => {
            return response.json();
          })
          .then(async (data) => {

            if (data.state.Code === 1004 || data.state.Code === 1077) {
              navigate("/limpiar_carrito");
              throw new Error(data.state.Message)
            }
            else if (data.state.Code !== 200) {
              throw new Error(data.state.Message)
            }

            //Meta Pixel Add to Cart
            window.fbq("track", "AddToCart", {
              content_ids: [producto.Codigo]
            });

            //GA add to cart
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              'event': 'add_to_cart',
              'ecommerce': {
                'add': {
                  'products': [{
                    'id': producto.Codigo,
                    'name': producto.Descripcion,
                    'category': producto.AreaFuncional,
                    'brand': producto.Marca,
                    'price': producto.PrecioNormal,
                    'quantity': 1
                  }]
                }
              }
            });

            //Validar si el producto tienen promociones condicionales
            let promosTemp = await ObtenerPromociones(producto)

            if (promosTemp.length > 0) {
              setPromos(promosTemp)
            } else {
              appContext.setAppState((values) => {
                return { ...values, cntItemsCarrito: data.Response.CantidadArticulos }
              })
              Swal.fire({
                title: '',
                text: 'Producto añadido al carrito',
                icon: 'success',
                showDenyButton: true,
                confirmButtonText: 'Ir a mi carrito',
                confirmButtonColor: 'DarkOrange',
                denyButtonText: "Seguir comprando",
                denyButtonColor: "Orange"
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/carrito")
                }
              })
            }
          })
          .catch((error) => {
            throw error
          });
      }
    } catch (e) {
      Swal.fire({
        title: 'Lo sentimos',
        text: e.toString(),
        icon: 'error',
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonText: 'Ver productos similares',
        confirmButtonColor: 'DarkOrange',
        denyButtonText: 'Cambiar método de entrega',
        didRender: () => {
          const swalPopup = Swal.getPopup();

          if (swalPopup) {
            const buttonsContainer = document.createElement('div');
            buttonsContainer.style.display = 'flex';
            buttonsContainer.style.flexDirection = 'column';
            buttonsContainer.style.gap = '10px';
            buttonsContainer.style.alignItems = 'center';

            const confirmButton = swalPopup.querySelector('.btn-alert-swal-orange');
            const denyButton = swalPopup.querySelector('.btn-alert-swal-deny');

            if (confirmButton && denyButton) {
              confirmButton.style.width = '60%';
              denyButton.style.width = '60%';
              confirmButton.style.margin = '0';
              denyButton.style.margin = '0';

              buttonsContainer.appendChild(confirmButton);
              buttonsContainer.appendChild(denyButton);
              swalPopup.appendChild(buttonsContainer);
            }
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/Similares/" + producto.Codigo.toLowerCase());
        } else if (result.isDenied) {
          sessionStorage.setItem("codigo", producto.Codigo);
          navigate("/entrega");
        }
      });
    }
    finally {
      setLoaderCompra(false);
    }
  }

  const AñadirFavorito = async () => {

    try {
      setLoaderFavorito(true);

      if (localStorage.getItem("app-token") === null || localStorage.getItem("app-token") === "") {
        navigate("/login")
      }
      else {
        if (props.Producto.EsFavorito) {
          var response = await fetch(
            new Request(appContext.appState.baseUrl + 'producto/favorito', {
              method: "PUT",
              body: JSON.stringify({
                estado: 0,
                codigoInventario: props.Producto.Codigo
              }),
              headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("app-token")
              }
            })
          )

          if (response.status === 200) {
            //var data = await response.json();

            props.Producto.EsFavorito = false;
            setFavorito(false);

            Swal.fire({
              title: 'Exitoso',
              text: 'Retirado de favoritos',
              icon: 'success',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: 'Orange',
            })

          } else {

            let data = await response.json();

            if (data.state.Code === 999) {
              Swal.fire({
                title: 'Lo sentimos',
                text: 'Token Invalido: Tiempo expirado',
                icon: 'error',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: 'Orange',
              }).then((result) => {
                navigate("/usuario/clear");
              })
            }
            else if (data.state.Code !== 200) {
              throw new Error(data.state.Message)
            }
          }

        } else {
          let response = await fetch(
            new Request(appContext.appState.baseUrl + 'producto/favorito', {
              method: "POST",
              body: JSON.stringify({
                estado: 1,
                codigoInventario: props.Producto.Codigo
              }),
              headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("app-token")
              }
            })
          )

          if (response.status === 200) {
            //let data = await response.json();

            props.Producto.EsFavorito = true;
            setFavorito(true);

            Swal.fire({
              title: 'Exitoso',
              text: 'Agregado a favoritos',
              icon: 'success',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: 'Orange',
            })

          } else {
            let data = await response.json();

            if (data.state.Code === 999) {
              Swal.fire({
                title: 'Lo sentimos',
                text: 'Token Invalido: Tiempo expirado',
                icon: 'error',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: 'Orange',
              }).then((result) => {
                navigate("/usuario/clear");
              })
            }
            else if (data.state.Code !== 200) {
              throw new Error(data.state.Message)
            }
          }
        }
      }
    } catch (err) {
      Swal.fire({
        title: 'Lo sentimos',
        text: err.toString(),
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: 'Orange',
      })
    }
    finally {
      setLoaderFavorito(false);
    }
  }

  const ObtenerPromociones = async (producto) => {
    try {
      var response = await fetch(
        new Request(appContext.appState.baseUrl + 'producto/obtenerPromoCondis/' + producto.Codigo, {
          method: "GET",
        })
      )
      if (response.status === 200) {
        var data = await response.json();
        return data.Response
      } else {
        let data = await response.json();
        if (data.state.Code === 999) {
          Swal.fire({
            title: 'Lo sentimos',
            text: 'Token Invalido: Tiempo expirado',
            icon: 'error',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: 'Orange',
          }).then((result) => {
            navigate("/usuario/clear");
          })
        }
        else if (data.state.Code !== 200) {
          throw new Error(data.state.Message)
        }
      }
    } catch (err) {
      Swal.fire({
        title: 'Lo sentimos',
        text: err.toString(),
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: 'Orange',
      })
    }
  }

  return (
    <>
      {promos.length > 0 ? <><PromoCondi productos={promos}></PromoCondi></> : <></>}
      <div
        title={existenciasPopUp.length > 0 ? "Existencias: \n" + existenciasPopUp : "No hay existencias en tiendas"}
        onContextMenu={(e) => {
          e.preventDefault()
          window.open("/precios_stock_detallado/" + props.Producto.Codigo.toLowerCase(), "_blank")
        }}
        onMouseDown={(e) => {
          if (e.button === 1) {
            e.preventDefault()
            window.open("/precios_stock_detallado/" + props.Producto.Codigo.toLowerCase(), "_blank")
          }
        }}
        className={JSON.stringify(appContext.appState.tiendaEntrega) !== "{}"
          ? props.Producto.Existencia.some(x => { if (x.CodigoSucursal === appContext.appState.tiendaEntrega.codigo.toString()) return x }) === false
            ?
            "grupo-producto card-de-producto card-de-producto-no-disponible" : "grupo-producto card-de-producto" : "grupo-producto card-de-producto"}
      >
        <div className="card-imagen-acciones" style={{ position: "absolute" }} >
          <ButtonWithIcon
            icon={< IconHeartPlus width={23.75} height={24} fill={'#DBDBDB'} />}
            loading={loaderFavorito}
            onClick={AñadirFavorito}
            className={isFavorito ? 'buttonWithIcon-whiteghost-light-active' : 'buttonWithIcon-whiteghost-light'}
            margin={0}
          ></ButtonWithIcon>
          <div></div>
          <ButtonWithIcon
            icon={< IconAddShoppingCart width={23.75} height={24} fill={'#DBDBDB'} />}
            loading={loaderCompra}
            onClick={() => AñadirProducto(props.Producto, props.Producto.Existencia)}
            className='buttonWithIcon-whiteghost-light'
            margin={0}
          ></ButtonWithIcon>
        </div>
        <div className="card-imagen" onClick={() => { navigate("/precios_stock_detallado/" + props.Producto.Codigo.toLowerCase()) }}>
          <div className="card-imagen-etiqueta no-select">

            {JSON.stringify(appContext.appState.tiendaEntrega) !== "{}"

              ? props.Producto.Existencia.some(x => {
                if (x.CodigoSucursal === appContext.appState.tiendaEntrega.codigo.toString()) return x
              }) === false
                ?
                <div onClick={(e) => {
                  e.stopPropagation()
                  Swal.fire({
                    title: 'Lo sentimos',
                    text: 'El producto no se encuentra disponible para el método de entrega seleccionado',
                    icon: 'warning',
                    showDenyButton: true,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: 'Orange',
                    denyButtonText: "Cambiar método de entrega",
                  }).then((result) => {
                    if (result.isDenied) {
                      sessionStorage.setItem("codigo", props.Producto.Codigo)
                      navigate("/entrega")
                    }
                  })
                }} title="El producto no se encuentra disponible para el método de entrega seleccionado" style={{ display: "flex", alignItems: "center" }} className="card-imagen-etiqueta-texto card-imagen-etiqueta-texto-gray" >No disponible
                  <IconHelpFill height={14} width={14} fill={"#a6a6a7"} />

                </div>
                : ((new Date() - new Date(props.Producto.FechaCreacion)) / 1000 / 60 / 60 / 24 / 30) <= 3
                  ? <div className="card-imagen-etiqueta-texto card-imagen-etiqueta-texto-green" >Recién Ingreso</div>
                  : <div className="card-imagen-etiqueta-texto" style={{ opacity: "0" }}></div>
              :
              ((new Date() - new Date(props.Producto.FechaCreacion)) / 1000 / 60 / 60 / 24 / 30) <= 3
                ? <div className="card-imagen-etiqueta-texto card-imagen-etiqueta-texto-green" >Recién Ingreso</div>
                : props.Etiqueta !== undefined
                  ? <div className="card-imagen-etiqueta-texto" >{props.Etiqueta}</div>
                  : <div className="card-imagen-etiqueta-texto" style={{ opacity: "0" }}></div>
            }

            <div className="card-imagen-etiqueta-imagenx">
              {props.Producto.FechaCaducaDescuento === undefined | props.Producto.FechaCaducaDescuento === null | props.Producto.FechaCaducaDescuento === "" | props.Producto.FechaCaducaDescuento === "01/01/0001"
                ? <div style={{ opacity: "0" }}></div>
                : <div style={{ background: "rgb(240, 118, 29)", fontSize: "10px", color: "white", borderRadius: "25px", padding: "5px 10px 5px 10px", fontWeight: "600", display: "flex", alignItems: "center" }}>¡Oferta!</div>}
            </div>
          </div>
          <div className="card-imagen-img no-select">
            {errorImage === false
              ? <img src={props.Producto.Codigo.toLowerCase() === 'dvd+r-max-1c' ? props.Producto.Imagen.replace("+", "") : props.Producto.Imagen} onError={() => { setErrorImage(true) }} alt="producto" loading="lazy" />
              : <img src={NoImage} alt="No disponible" loading="lazy" />
            }
          </div>

          {props.Producto.FechaCaducaDescuento === undefined | props.Producto.FechaCaducaDescuento === null | props.Producto.FechaCaducaDescuento === "" | props.Producto.FechaCaducaDescuento === "01/01/0001"
            ? <div className="card-imagen-validez" style={{ opacity: "0" }}><div ></div>    </div>
            : <div className="card-imagen-validez no-select"> <div>OFERTA VÁLIDA HASTA EL {props.Producto.FechaCaducaDescuento}</div>    </div>}

        </div>
        <div className="card" onClick={() => { navigate("/precios_stock_detallado/" + props.Producto.Codigo.toLowerCase()) }}>
          <div className="marcaproducto">{props.Producto.Marca}</div>
          <div className="descripcionproducto">{props.Producto.Descripcion}</div>
          <div className="precioanterior hidden">Precio anterior {props.Producto.PrecioAnterior.toCurrency()}</div>

          {
            mayorista === true ?
              <>
                <div className="precioproducto"><span className="precioproducto-label">Precio Mayorista</span> {props.Producto.PrecioNormal.toCurrency()}</div>
              </> :
              <>
                <div className="precioproducto"><span className="precioproducto-label">Precio normal</span> {props.Producto.PrecioNormal.toCurrency()}</div>
                <div className="beneficioEfectivo" style={{ marginTop: "-5px" }}>{props.Producto.DescripcionDescuento} {props.Producto.PrecioDescuento.toCurrency()}</div>
              </>
          }
          <div className="mensaje no-select">{PRECIO_CONDICION}</div>
        </div>
      </div>
    </>
  )

}

export default ProductoCard